module.exports = __webpack_public_path__ + "static/wildgeese-3bacf1248d57336806d784f508e440e8.jpg";